<template>
  <div class="animation-item-player">
    <img v-if="isHovered" :src="src" @error="$_onError" />
    <img
      v-show="!isHovered && previewImageReady"
      ref="thumbnail"
      alt="first frame"
    />
  </div>
</template>

<script>
import { workPool } from '@wochitnpm/helpers';

export default {
  name: 'AnimationItemPlayer',

  props: {
    isHovered: { type: Boolean, required: true },
    src: { type: String, required: true },
  },

  data() {
    return {
      srcFirstFrame: null,
      previewImageReady: false,
    };
  },

  beforeDestroy() {
    workPool.off(this.$options.workPoolHandlers);
  },

  watch: {
    src() {
      this.$_captureFirstFrame();
    },
  },

  mounted() {
    this.$_captureFirstFrame();
  },

  methods: {
    $_captureFirstFrame() {
      this.$options.workPoolHandlers = new Set();
      workPool.job.captureFirstFrame.execute({ src: this.src });
      workPool.once(
        {
          type: workPool.job.captureFirstFrame.type,
          context: (jc) => jc.src === this.src,
        },
        (payload) => {
          if (this._isDestroyed) {
            return;
          }
          if (payload.error) {
            this.$_onError();
          } else {
            workPool.job.captureFirstFrame.applyFirstFrameImage({
              ...payload,
              image: this.$refs.thumbnail,
            });
            this.previewImageReady = true;
          }
        },
        this.$options.workPoolHandlers
      );
    },

    $_onError() {
      this.$emit('error');
    },
  },
};
</script>

<style lang="scss">
.animation-item-video {
}
</style>
